import React, { memo } from "react";
import AtivoImovel from "./AtivoImovel";
import { Stack, Typography, Box } from "investira.react.components";
const AtivoImoveis = memo(props => {
  const {
    ativo
  } = props;
  if (process.env.NODE_ENV === "production") {
    return null;
  }
  if (!["CTIM"].includes(ativo.ativo_tipo_id)) {
    return null;
  }
  const xData = [{
    imovel: "DCC - Distribuition Center Cajamar",
    area: 95730,
    unidades: 1,
    vacancia: null,
    inadimplencia: null,
    percentualDaReceita: 4.16,
    percentualLocado: null,
    totalInvestidoDoFII: null,
    endereco: "Rua da Harmonia - Parque Industrial de Betim, Betim - MG",
    caracteristicas: null
  }, {
    imovel: "HGLG Louveira",
    area: 78500,
    unidades: 2,
    vacancia: 5.2,
    inadimplencia: 1.8,
    percentualDaReceita: 3.75,
    percentualLocado: 94.8,
    totalInvestidoDoFII: 45000000,
    endereco: "Avenida das Indústrias, 1000 - Distrito Industrial, Contagem - MG",
    caracteristicas: "Galpão logístico"
  }, {
    imovel: "Tech Town",
    area: 120000,
    unidades: 1,
    vacancia: null,
    inadimplencia: 0.5,
    percentualDaReceita: 5.2,
    percentualLocado: 100,
    totalInvestidoDoFII: 80000000,
    endereco: "Rodovia BR-381, km 450 - Jardim Riacho das Pedras, Betim - MG",
    caracteristicas: "Centro de distribuição"
  }, {
    imovel: "Master Labs",
    area: 65000,
    unidades: 3,
    vacancia: 10,
    inadimplencia: null,
    percentualDaReceita: 2.8,
    percentualLocado: 90,
    totalInvestidoDoFII: 35000000,
    endereco: "Rua das Acácias, 500 - Jardim Industrial, Ibirité - MG",
    caracteristicas: "Condomínio industrial"
  }, {
    imovel: "Condomínio SJC",
    area: 88000,
    unidades: 1,
    vacancia: 0,
    inadimplencia: 2.1,
    percentualDaReceita: 3.9,
    percentualLocado: 100,
    totalInvestidoDoFII: 55000000,
    endereco: "Avenida General David Sarnoff, 2500 - Cidade Industrial, Contagem - MG",
    caracteristicas: "Fábrica"
  }, {
    imovel: "DCR - Distribuition Center Rodoanel",
    area: 105000,
    unidades: 2,
    vacancia: 15,
    inadimplencia: 3.5,
    percentualDaReceita: 4.5,
    percentualLocado: 85,
    totalInvestidoDoFII: 70000000,
    endereco: "Rua Doutor Júlio de Abreu, 300 - Eldorado, Sete Lagoas - MG",
    caracteristicas: "Complexo industrial"
  }];
  return <Stack spacing={2}>
      <Stack>
        <Typography variant="subtitle1" color="textPrimary" sx={{
        fontWeight: 600
      }}>
          Imóveis do {ativo.ticker}
        </Typography>
      </Stack>
      <Box sx={{
      display: "grid",
      gridTemplateColumns: {
        xs: "repeat(1, 1fr)",
        sm: "repeat(2, 1fr)",
        md: "repeat(3, 1fr)"
      },
      gap: 1.5
    }}>
        {xData.map(xImovel => {
        return <AtivoImovel data={xImovel} />;
      })}
      </Box>
    </Stack>;
});
AtivoImoveis.propTypes = {};
export default AtivoImoveis;
